const UPDATE_PROFILE_STATUS = 'UPDATE_PROFILE_STATUS';
const UPDATE_HAS_IDENTITY = 'UPDATE_HAS_IDENTITY';

export {
    UPDATE_PROFILE_STATUS, UPDATE_HAS_IDENTITY
};
